// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"dataBox--next-sr-only--1ql9s_o","data-box":"dataBox--data-box--rD0GSom","title":"dataBox--title--3mkKQkq","value":"dataBox--value--2JFI_0h"};